// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"58ba4bc5","69":"c0d5b93e","760":"42d9bf43","775":"29778dc3"}[chunkId] + ".chunk.css";
};